import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  PostDocumentPackageRequestType,
  PostDocumentPackageResponseType,
} from '../types';

export const postDocumentPackage = async (
  params: PostDocumentPackageRequestType,
) => {
  const url = '/api/v2/document-packages';

  const formData = new FormData();

  formData.append('board_id', params.boardId.toString());
  formData.append('package_name', params.packageName);
  formData.append('sign_type', params.signType);

  params.files.forEach(file => {
    formData.append('files[]', file);
  });

  if (params.documentNames) {
    params.documentNames.forEach((name, index) => {
      if (name) {
        formData.append(`document_names[${index}]`, name);
      }
    });
  }

  const { data } =
    await apiAuthClient.postForm<PostDocumentPackageResponseType>(
      url,
      formData,
    );

  return data;
};
